import { IconRoute } from "../icon/variants/IconRoute.js";
import { Flex } from "../mantine-passthroughs/index.js";
import { Body1 } from "../typography/Body1.js";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/distance/Distance.tsx
/**
* A flexible component to display distance information
*/
const Distance = ({ distance, locale = "en-US", units, iconColor = "primary", showIcon = true, "data-testid": testId }) => {
	const formattedDistance = new Intl.NumberFormat(locale, {
		style: "decimal",
		maximumFractionDigits: 2
	}).format(distance);
	return /* @__PURE__ */ jsxs(Flex, {
		align: "center",
		gap: "xxs",
		"data-testid": testId,
		children: [showIcon ? /* @__PURE__ */ jsx(IconRoute, {
			color: iconColor,
			style: { transform: "rotate(90deg)" }
		}) : void 0, /* @__PURE__ */ jsx(Body1, { children: `${formattedDistance} ${units}` })]
	});
};

//#endregion
export { Distance };